import React, { useEffect } from 'react'
import CancelIcon from '@mui/icons-material/Cancel'
import makeStyles from '@mui/styles/makeStyles'
import { Box, AppBar, Toolbar, Paper } from '@mui/material'

import { Logo } from '../Common/Logo'

const useStyles = makeStyles(() => ({
  errorIcon: {
    marginTop: '85px',
    fontSize: 100,
    color: 'white',
    marginLeft: '532px',
  },

  errorMessage: {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    textAlign: 'center',
    color: 'white',
  },

  errorDescription: {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    textAlign: 'center',
    color: 'white',
  },

  errorRedirect: {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    textAlign: 'center',
    color: 'white',
  },

  errorContainer: {
    height: '520px',
    width: '100%',
    marginLeft: '0px',
  },
}))

export function ErrorPage({ handleLogout, message }): JSX.Element {
  const classes = useStyles()
  useEffect(() => {
    const timeout = setTimeout(handleLogout, 60000)
    return () => clearTimeout(timeout)
  }, [])
  return (
    <Box style={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ color: '#0A688D', backgroundColor: 'rgba(255, 255, 255, 1)' }}>
        <Toolbar>
          <div color="inherit" style={{ flexGrow: 1, padding: '8px' }}>
            <Logo width={'126'} height={'70'} />
          </div>
        </Toolbar>
      </AppBar>
      <Paper
        elevation={3}
        sx={{ p: '24px', width: '77%', backgroundColor: 'rgb(10, 104, 141)', marginTop: '30px', marginLeft: '175px' }}
      >
        <div style={{ flexGrow: 1, justifyContent: 'center' }}>
          <div className={classes.errorContainer}>
            <CancelIcon className={classes.errorIcon} />
            <h1 className={classes.errorMessage}>{message}</h1>
            <h4 className={classes.errorDescription}> Please contact administrator for additional support </h4>
            <p className={classes.errorRedirect}> You will be redirected back to the login screen in a few seconds </p>
          </div>
        </div>
      </Paper>
    </Box>
  )
}
